<div class="view-dashboard">
    <div class="header8" *ngIf="dealer">Viewing the dashboard of dealers in {{dealer.name}}</div>
    <div layout="row">
        <mat-spinner class="loading-spinner" *ngIf="isLoading"></mat-spinner>
        <div *ngIf="!isLoading" class="container">
            <h3 *ngIf="noCharts && !isLoading" class="not-found-container">
                <img class="not-found-icon" src="../../assets/not_found.svg" />
                <p class="not-found-text header-text subtitle2">
                    {{plaintext.dashboard.ncf[user.language]}}
                </p>
            </h3>
            <div *ngFor="let chart of userCharts" class="chart">
                <app-chart flex [chart]="chart" [hasModal]="true">
                </app-chart>
            </div>
        </div>
    </div>
</div>